export default __webpack_public_path__ + "static/media/leaf2.31c490c0.png";